// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea00110b","239":"af8f8017","453":"013d9752","667":"c7b346e9","975":"712b8e1e"}[chunkId] + ".chunk.js";
};